<template>
  <div class="add headFixed">
    <div class="topHead">
      <router-link :to="'/equipment/timer/'+this.getId()"><span class="cancel" @click="cancelAddTimer">取消</span>
      </router-link>
      <span>添加定时</span>
      <span class="save" @click="addTimerTask">保存</span>
    </div>
    <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
    <div class="list list_normal list_info" style="margin-top:10px">
      <div class="item">
        <div class="clear">
          <p @click="showTimerModal">重复 <span class="right">{{ this.dateStr }}</span></p>
        </div>
        <div v-if="this.$route.params.type ==3 " class="clear">
          <p>绑定模式
            <span class="right">
              <input class="input" type="radio" name="mode" value="1" v-model="mode" checked>
              <label>绑定制热</label>
              <input class="input" type="radio" name="mode" value="2" v-model="mode">
              <label>绑定制冷</label>
            </span>
          </p>
        </div>
        <div v-if="this.$route.params.type ==3 " class="clear">
          <p @click="showTempModal">温度 <span
              class="right">{{ this.temperature === -1 ? '点击设置温度' : this.temperature + '°C' }}</span></p>
        </div>
      </div>
    </div>

    <mt-popup v-model="showTemp" class="pubPopup" position="bottom" defaultIndex="3">
      <p class="tipText tip-text-border">温度选择</p>
      <mt-picker :slots="mode==='1'?slotsHotTemp:slotsCodeTemp"
                 @change="onChangeTemp"
                 ref="mainDegrees"></mt-picker>
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="changeTempModal">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelTempModal">取消</mt-button>
      </p>
    </mt-popup>

    <div class="modal timerModal" :class="this.showTimer?'':'hide'">
      <mt-checklist
          title=""
          v-model="value"
          :options="this.checklist">
      </mt-checklist>
      <div class="btns">
        <mt-button size="large" class="btn-orange" @click="sureTimer">确定</mt-button>
        <mt-button size="large" @click="cancelTimer">取消</mt-button>
      </div>
    </div>
  </div>
</template>
<script>
import {Checklist, Picker, Popup, Toast} from 'mint-ui';

export default {
  name: 'detail',
  data() {
    return {
      value: [],
      popupVisible: true,
      showTimer: false,
      showTemp: false,
      mode: '1',
      temperature: -1,
      temp: null,
      options: [
        {
          label: "制热",
          value: '1'
        },
        {
          label: "制冷",
          value: '2'
        },
      ],
      slotsCodeTemp: [
        {
          values: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        }
      ],
      slotsHotTemp: [
        {
          values: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
        }
      ],
      slots: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
        }, {
          divider: true,
          content: '-',
          className: 'slot2'
        }, {
          flex: 1,
          values: [],
          className: 'slot3',
          textAlign: 'center'
        }
      ],
      dateStr: '',
      date: ['1', '2', '3', '4', '5', '6', '7'],
      time: '16:00',
      checklist: [
        {
          label: '周一',
          value: '1'
        },
        {
          label: '周二',
          value: '2'
        },
        {
          label: '周三',
          value: '3'
        },
        {
          label: '周四',
          value: '4'
        },
        {
          label: '周五',
          value: '5'
        },
        {
          label: '周六',
          value: '6'
        },
        {
          label: '周日',
          value: '7'
        },
      ]
    }
  },
  beforeMount() {
    let values = [], vals = [];
    for (let i = 0; i < 24; i++) {
      let str = '0';
      if (String(i).length < 2) {
        str = '0' + String(i);
      } else {
        str = i;
      }
      values.push(str);
    }
    for (let i = 0; i < 60; i++) {
      let str = '0';
      if (String(i).length < 2) {
        str = '0' + String(i);
      } else {
        str = i;
      }
      vals.push(str);
    }
    this.slots[0].values = values;
    this.slots[2].values = vals;
    // this.slots[4].values = vals;
  },
  mounted() {
    this.transDate(this.date)
  },
  watch: {
    mode(newMode) {
      if (newMode === '1') {
        this.temperature = -1; // 制热模式下的默认温度
      } else if (newMode === '2') {
        this.temperature = -1; // 制冷模式下的默认温度
      }
    }
  },
  methods: {
    onValuesChange(picker, values) {
      this.time = values.join(':');
    },
    showDateModal() {
      this.popupVisible = true;
    },
    cancelAddTimer() {

    },
    getId() {
      return this.$route.params.id;
    },
    addTimerTask() {
      let self = this;
      if (this.$route.params.type == 3) {
        if (this.temperature == undefined || this.temperature == -1) {
          Toast("温度不能为空")
          return;
        }
        if (this.mode == undefined || this.mode == -1) {
          Toast("需要选择绑定模式")
          return;
        }
      }else {
        let data = {
          "iotDeviceId": this.$route.params.id,
          "daysOfWeek": this.date.join(','),
          "time": this.time,
          "type": this.$route.params.type,
          "temperature": this.temperature,
          "mode": this.mode
        }
        this.Api.addTimerTask(data, function (msg) {
          if (msg.code == 200) {
            self.$router.push({path: '/equipment/timer/' + self.$route.params.id})
          }
          if (msg.code == 402) {
            Toast(msg.message);
          }

        })
      }

    },
    updateTimerTask() {
      let params = {};
      params.id = 15;
      params.executionTime = this.date.join(',') + ' 12:00:00';
      params.executionType = 1;
      this.Api.updateTimerTask(params, function (msg) {
        console.log(msg)
      })
    },
    cancelTimer() {
      this.showTimer = false;
    },
    showTimerModal() {
      this.showTimer = true;
    },
    showTempModal() {
      this.showTemp = true;
    },
    cancelTempModal() {
      this.showTemp = false;
    },
    changeTempModal() {
      this.temperature = this.temp[0];
      this.showTemp = false;
    },
    sureTimer() {
      this.date = this.value;
      this.transDate(this.value)
      this.showTimer = false
    },
    onChangeTemp(picker, values) {
      this.temp = values;
    },
    transDate(date) {
      date.sort();
      let arr = [];
      for (let i = 0; i < date.length; i++) {
        let key = date[i];
        switch (key) {
          case '1':
            arr.push('周一');
            break;
          case '2':
            arr.push('周二');
            break;
          case '3':
            arr.push('周三');
            break;
          case '4':
            arr.push('周四');
            break;
          case '5':
            arr.push('周五');
            break;
          case '6':
            arr.push('周六');
            break;
          default:
            arr.push('周日');
        }
        this.dateStr = arr.join(',')
      }
    }
  }

}
</script>

<style scoped>
@import url('../../../assets/list.css');
@import url('./style/timer.css');

.input {
  border: none;
  border-bottom: 1px solid #DCDCDC;
  padding-left: 10px;
  width: auto;
  height: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/equipment/timer/addTimer.vue